import React from "react";

import { templates } from "@reactivated";

// Default implementation renders nothing — tempurpedic overrides this
// with the actual OutOfContextBundleCollection container.
export const Template = (
    _props: templates.PDPBundlesTemplate,
): React.JSX.Element | null => {
    return null;
};
